import {
  GET_TERM,
  GET_TERM_SUCCESS,
  GET_TERM_ERROR,
  DELETE_TERM,
  DELETE_TERM_SUCCESS,
  DELETE_TERM_ERROR
} from "../actions";

const INIT_STATE = {
  termId: null,
  term: null,
  termDetailsError: "",
  recordList : null,
  trashTermSuccess: "",
  trashTermError: "",
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_TERM:
      return {
        ...state,
        loading: true,
        termId: action.payload.termId,
        termDetailsError: "",
      };
    case GET_TERM_SUCCESS:
      return {
        ...state,
        loading: false,
        termDetailsError: "",
        term: action.payload.term
      };
    case GET_TERM_ERROR:
      return { ...state, loading: false, termDetailsError: action.payload ? action.payload.message : "" };
    case DELETE_TERM:
      return {
        ...state,
        loading: true,
        termId: action.payload.termId,
        trashTermError: "",
        trashTermSuccess: "",
      };
    case DELETE_TERM_SUCCESS:
      return {
        ...state,
        loading: false,
        trashTermSuccess: action.payload ? action.payload.successMessage : "",
      };
    case DELETE_TERM_ERROR:
      return {
        ...state,
        loading: false,
        trashTermError: action.payload ? action.payload.message : "",
      };
    default:
      return { ...state };
  }
};
